/**
 * Where to navigate after a successful login: the requested `returnUrl` wins;
 * without one (or with the plain root), TestCompany accounts land on the
 * action-modules page instead of the dashboard.
 */
export function resolveLoginDestination(returnUrl: string | null, features: string[] | null | undefined): string {
  const destination = returnUrl || '/'
  if ((features ?? []).includes('TestCompany') && destination === '/') {
    return '/actionmodules'
  }
  return destination
}
